import React, { ReactNode, useCallback, useEffect, useState } from "react";
import { Button, Tooltip } from "@material-tailwind/react";
import Card from "../../../design-system/Card";
import { MdOutlineDeleteForever } from "react-icons/md";
import { FiCheck } from "react-icons/fi";
import { RxCross2 } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../state/store";
import { OptionRefactorPayload, errorToast, successToast } from "../../../utils/common";
// import { createNewOption, regenerateChallengeOption } from "../../../api";
import { updateCaselet } from "../caseletSlice";
import { handleUpdateCaseletClick } from "../../thoughts/chat/ChatCardButton";
import { Input } from "@material-tailwind/react";
import { ToastContainer } from "react-toastify";
import { NewDecisionPointFormValues } from "./Challenges";
import CardVideo from "../../../design-system/CardVideo";


export interface DecisionPointProps {
    decisionPointTitle: string;
    published: boolean;
    isDecisionPointGenerating?: boolean;
    caseletId: string;

    setActiveTabToChallenge?: (data: number) => void;
    sendNewOptionFlag?: (flag: boolean) => void;
    updateNewOptionStatus?: boolean;
}
interface ChallengeProps extends DecisionPointProps {
    challenge?: string;
    setActiveTabToDecisionPoint?: (data: number) => void;
}
interface OptionsProps extends DecisionPointProps {
    options: string[];
    challenge?: string;
    setNewOptionsDetailFromOption?: (flag: boolean) => void;
}

interface VideoProps {
    thumbnail: string;
    title: string;
}

interface VideosProps {
    videos?: string[];
}
export const newChallenge: NewDecisionPointFormValues = {
    title: "",
    challenge: "",
    options: [],
    videos: []
};
const Challenge = ({ challenge, caseletId, decisionPointTitle, setActiveTabToDecisionPoint, published }: ChallengeProps) => {
    function setActiveTabFromCard(data: number) {
        if (typeof setActiveTabToDecisionPoint == "function") {
            setActiveTabToDecisionPoint(data);
        }
    }
    return (
        <div>
            <div>
                <Card
                    title="Challenge"
                    caseletId={caseletId}
                    content={challenge}
                    decisionPointTitle={decisionPointTitle}
                    setActiveTabToChallenge={setActiveTabFromCard}
                    published={published}
                />
            </div>
        </div>
    );
};

const Options = ({ options, decisionPointTitle, challenge, caseletId, published, setNewOptionsDetailFromOption, isDecisionPointGenerating }: OptionsProps) => {
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const [addingOption, setAddingOption] = useState(false);
    const [isChallengeEmpty, setIsChallengeEmpty] = useState(true);
    const [addNewOptionToolTipMessage, setAddNewOptionToolTipMessage] = useState("");
    const [addNewOptionToolTipStyle, setAddNewOptionToolTipStyle] = useState("");
    const [addNewOptionButtonStyle, setAddNewOptionButtonStyle] = useState("");

    const caseletData = useSelector((state: RootState) => state.caselet);
    const dispatch = useDispatch<AppDispatch>();
    let indexNumber = decisionPointTitle?.charAt(decisionPointTitle?.length - 1);
    const optionRefactorPayload: OptionRefactorPayload = {
        caselet: caseletData,
        index: Number.parseInt(indexNumber)
    };

    useEffect(() => {
        if (
            localStorage.getItem(caseletId.concat("-" + decisionPointTitle)) !== null &&
            localStorage.getItem(caseletId.concat("-" + decisionPointTitle)) !== ""
        ) {
            setInputValue(localStorage.getItem(caseletId.concat("-" + decisionPointTitle)) || "");
            setAddingOption(true);
            if (typeof setNewOptionsDetailFromOption === "function") {
                setNewOptionsDetailFromOption(true);
            }
        } else {
            setInputValue("");
            setAddingOption(false);
            if (typeof setNewOptionsDetailFromOption === "function") {
                setNewOptionsDetailFromOption(false);
            }
        }

        checkForUnSavedOptionsData();
    }, [decisionPointTitle]);

    function checkForUnSavedOptionsData() {
        for (var key of Object.keys(localStorage)) {
            if (key.includes("Decision Point")) {
                console.log("the useEffect is getting triggered");
                const keyValue = localStorage.getItem(key);
                if (keyValue !== null && keyValue !== "") {
                    if (typeof setNewOptionsDetailFromOption === "function") {
                        setNewOptionsDetailFromOption(true);

                    }
                    break;
                } else {
                    if (typeof setNewOptionsDetailFromOption === "function") {
                        setNewOptionsDetailFromOption(false);
                    }
                }
            } else {
                if (typeof setNewOptionsDetailFromOption === "function") {
                    setNewOptionsDetailFromOption(false);
                }
            }
        }
    }

    useEffect(() => {
        if (challenge === "") {
            setIsChallengeEmpty(true);
            setAddingOption(false);
            setAddNewOptionToolTipMessage("Add a challenge first !!");
            setAddNewOptionToolTipStyle("p-2 bg-gray-500 font-bold");
            setAddNewOptionButtonStyle("inactive-challenge-button-style");
        } else {
            setIsChallengeEmpty(false);
            if (addingOption) {
                setAddNewOptionToolTipMessage("Empty option already created");
                setAddNewOptionToolTipStyle("p-2 bg-gray-500 font-bold");
                setAddNewOptionButtonStyle("inactive-challenge-button-style");
            } else {
                setAddNewOptionToolTipMessage("Add new option manually");
                setAddNewOptionToolTipStyle("p-2 bg-green-800 font-bold");
                setAddNewOptionButtonStyle("active-challenge-button-style");
            }
        }
    }, [challenge, addingOption]);

    function addingNewOption() {
        setAddingOption(true);
        localStorage.setItem(`${caseletId}activeTab`, "challenges");
        if (typeof setNewOptionsDetailFromOption === "function") {
            setNewOptionsDetailFromOption(true);
        }
    }

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setInputValue(event.target.value);
        localStorage.setItem(caseletId.concat("-" + decisionPointTitle), event.target.value);
    };

    const handleSubmitNewOption = async () => {
        const updatedCaselet = JSON.parse(JSON.stringify(caseletData));
        var flag: boolean = false;
        var dpNumber = 0;
        for (var i = 0; i < updatedCaselet.challenges.length; i++) {
            if (updatedCaselet.challenges[i].title === decisionPointTitle) {
                console.log("inputValue: ", inputValue);
                updatedCaselet.challenges[i].options = updatedCaselet.challenges[i].options.concat(inputValue);
            }
            if (updatedCaselet.challenges[i].challenge === "") {
                flag = true;
                dpNumber = i + 1;
                updatedCaselet.challenges.pop(i);
            }
        }

        const result = await handleUpdateCaseletClick(updatedCaselet);

        var respCaselet = result.caselet;
        if (flag) {
            const newDP = {
                title: "Decision Point " + dpNumber,
                challenge: "",
                options: [],
                videos: []
            };

            respCaselet.challenges.push(newDP);
        }

        dispatch(updateCaselet(respCaselet));
        setInputValue("");
        localStorage.removeItem(caseletId.concat("-" + decisionPointTitle));
        setAddingOption(false);
        successToast("Success !!");

        checkForUnSavedOptionsData();
        if (localStorage.getItem(`${caseletId}isEmptyDecisionPointExist`) !== "true") {
            localStorage.removeItem(`${caseletId}activeTab`);
            localStorage.removeItem(`${caseletId}decisionPointName)`);
        }
        return;
    };

    const handleKeyDown = async (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            if (inputValue.trim().length !== 0) {
                await handleSubmitNewOption();
                localStorage.removeItem(`${caseletId}decisionPointName)`);
            }
        }
    };
    const handleCancelAddition = () => {
        let optionFlag = false;
        setInputValue("");
        setAddingOption(false);
        localStorage.removeItem(caseletId.concat("-" + decisionPointTitle));
        localStorage.removeItem(`${caseletId}decisionPointName)`);
        for (var key of Object.keys(localStorage)) {
            if (key.includes("Decision Point")) {
                optionFlag = true;
                break;
            }
        }
        if (!optionFlag) 
            localStorage.removeItem(`${caseletId}activeTab`);

        checkForUnSavedOptionsData();
    };

    async function handleOptionDelete(index: number) {
        const updatedCaselet = JSON.parse(JSON.stringify(caseletData));
        var emptyDecisionPointCheck: boolean = false;
        var dpNumber = 0;
        for (var i = 0; i < updatedCaselet.challenges.length; i++) {
            if (updatedCaselet.challenges[i].title === decisionPointTitle) {
                if (Array.isArray(updatedCaselet.challenges[i].options)) {
                    updatedCaselet.challenges[i].options.splice(index, 1);
                } else {
                    // console.error("options is not an array");
                    return;
                }
            }
            if (updatedCaselet.challenges[i].challenge === "") {
                emptyDecisionPointCheck = true;
                dpNumber = i + 1;
                updatedCaselet.challenges.pop(i);
            }
        }

        const result = await handleUpdateCaseletClick(updatedCaselet);
        var respCaselet = result.caselet;
        if (emptyDecisionPointCheck) {
            const newDP = {
                title: "Decision Point " + dpNumber,
                challenge: "",
                options: [],
                videos: []
            };

            respCaselet.challenges.push(newDP);
        }

        dispatch(updateCaselet(respCaselet));
        errorToast("Deleted !! ");
        checkForUnSavedOptionsData();
    }

    if (!options || options.length === 0) {
        options = [];
    }

    const renderAddOption = () => {
        return !isDecisionPointGenerating ? (
            !isChallengeEmpty ? (
                <Tooltip content={addNewOptionToolTipMessage} placement="right" className={addNewOptionToolTipStyle}>
                    <Button className={addNewOptionButtonStyle} onClick={() => addingNewOption()} disabled={addingOption}>
                        +
                    </Button>
                </Tooltip>
            ) : (
                <Tooltip content={addNewOptionToolTipMessage} placement="right" className={addNewOptionToolTipStyle}>
                    <Button className={addNewOptionButtonStyle} disabled>
                        +
                    </Button>
                </Tooltip>
            )
        ) : (
            ""
        );
    };
    return (
        <div className="py-4 ">
            <div>
                <div className="flex items-center  font-title rounded-lg mr-4 px-4">
                    <h2 className="mr-5 ">Options</h2>
                    {!published && renderAddOption()}
                </div>
               
                <div className="">
                    {options.map((displayOption, index) => (
                        <div key={index} className="mt-4  mx-4 p-4 w-2/3 rounded-xl shadow-md  items-center  bg-gray-300 space-x-4 justify-start list-disc">
                            <div className="font-content text-black flex justify-between  ">
                                <div className="hyphens-auto" style={{ maxWidth: "92%", overflowWrap: "break-word" }}>
                                    {displayOption}
                                </div>
                                <div className="px-2 hyphens-auto">
                                    {!published && !isDecisionPointGenerating && (
                                        <button>
                                            <MdOutlineDeleteForever
                                                className="ml-auto text-red-300 hover:text-red-800 hover:scale-125"
                                                onClick={() => handleOptionDelete(index)}
                                                size={22}
                                            />
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}

                    <div>
                        {addingOption ? (
                            <>
                                {!isDecisionPointGenerating ? (
                                    <div className="  mt-4  mx-4 p-4 w-2/3 rounded-xl shadow-md flex items-center  bg-gray-300 space-x-4 justify-start list-disc ">
                                        <textarea
                                            className="w-full no-resize p-2 "
                                            value={inputValue}
                                            style={{ maxWidth: "92%", overflowWrap: "break-word" }}
                                            placeholder="Add new Option"
                                            onChange={e => handleInputChange(e)}
                                            onKeyDown={handleKeyDown}
                                            autoFocus
                                            onFocus={e => {
                                                e.target.setSelectionRange(e.target.value.length, e.target.value.length);
                                            }}
                                        />

                                        <div className="text-green-600 hover:text-green-800">
                                            {inputValue.trim() ? (
                                                <button>
                                                    <FiCheck onClick={handleSubmitNewOption} size={20} />
                                                </button>
                                            ) : (
                                                <div className="pl-4"></div>
                                            )}
                                        </div>
                                        <div className="text-red-600 hover:text-red-800">
                                            <button>
                                                <RxCross2 onClick={handleCancelAddition} size={22} />
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    ""
                                )}
                            </>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>

            <ToastContainer />
        </div>
    );
};

const Videos = ({ videos }: VideosProps) => {
    function addNewVideo(): void {
        //console.log("Add new video functionality is not implemented yet.");
    }

    if (!videos || videos.length === 0) {
        // Check if videos are not present or empty
        return (
            <div>
                <CardVideo title="Videos" content="No videos Available" />
            </div>
        );
    }

    return (
        <div>
            <div className="flex pt-4 px-4">
                <div className="flex items-center justify-center font-title rounded-lg mr-4 px-4">
                    <h2>Videos</h2>
                </div>
                <Button onClick={addNewVideo} className="active-challenge-button-style">
                    +
                </Button>
            </div>
            <div className="flex flex-row space-x-2">
                {videos.map((video, index) => (
                    <div key={index} className="shadow-lg mx-4 my-4 rounded-lg bg-gray-300 ">
                        <div className="content-center" style={{ width: "320px", height: "180px" }}>
                            {/* Render video content here */}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

const DecisionPoint = (props: DecisionPointProps) => {
    const challenge = useSelector((state: RootState) => state.caselet.challenges.find(c => c.title === props.decisionPointTitle));

    const options = challenge ? challenge.options : [];
    const videos = challenge ? challenge.videos : [];

    function setActiveTabFromChallenge(data: number) {
        if (typeof props.setActiveTabToChallenge === "function") {
            props.setActiveTabToChallenge(data);
        }
    }

    function getNewOptionsDetailFromOption(flag: boolean) {
        if (typeof props.sendNewOptionFlag === "function") {
            props.sendNewOptionFlag(flag);
        }
    }

    return (
        <div>
            <Challenge
                challenge={challenge?.challenge}
                caseletId={props.caseletId}
                decisionPointTitle={props.decisionPointTitle}
                published={props.published}
                setActiveTabToDecisionPoint={setActiveTabFromChallenge}
            />
            <div className="bg-white rounded-lg mt-4 shadow-lg">
                <Options
                    options={options}
                    decisionPointTitle={props.decisionPointTitle}
                    caseletId={props.caseletId}
                    challenge={challenge?.challenge}
                    isDecisionPointGenerating={props.isDecisionPointGenerating}
                    published={props.published}
                    setNewOptionsDetailFromOption={getNewOptionsDetailFromOption}
                    updateNewOptionStatus={props.updateNewOptionStatus}
                />
            </div>
            <div className="bg-white rounded-lg mt-4 shadow-lg">
                <Videos videos={videos} />
            </div>
        </div>
    );
};

export default DecisionPoint;
